export const ASSET_TYPE_LABELS: Record<string, string> = {
  book: 'Sách',
  collection: 'Bộ sách',
  course: 'Khóa học',
  certificate: 'Chứng chỉ',
  material: 'Tài liệu',
};

// EBD chỉ cấp sách và bộ sách; các loại còn lại chỉ hiện khi có dữ liệu cũ.
export const EBD_ASSET_TYPES = ['book', 'collection'];

export const getAssetTypeLabel = (type: string) => ASSET_TYPE_LABELS[type] || type;

// Điền sẵn 0 cho loại EBD để vẫn hiện dòng khi API chưa trả khoá đó.
export const getVisibleAssetTypeCounts = (byType: Record<string, number> = {}) =>
  Object.entries({ ...Object.fromEntries(EBD_ASSET_TYPES.map((type) => [type, 0])), ...byType }).filter(
    ([type, count]) => EBD_ASSET_TYPES.includes(type) || count > 0
  );

export const getAssetTypePercent = (count: number, total: number) => (total ? (count / total) * 100 : 0);

// Bám theo dashboard để loại nào đang đếm được thì lọc được; giữ loại đang chọn để select không mất giá trị.
export const getFilterableAssetTypes = (byType?: Record<string, number>, selected?: string) => {
  const types = [...EBD_ASSET_TYPES, ...getVisibleAssetTypeCounts(byType).map(([type]) => type)];
  if (selected) types.push(selected);
  return Array.from(new Set(types));
};
